import Swiper, { Autoplay, Lazy } from 'swiper';

Swiper.use([Autoplay, Lazy]);

const homeSlider = new Swiper('.home-slider__container__slider', {
  slidesPerView: 1,
  slidesPerColumn: 1,
  spaceBetween: 30,
  preloadImages: false,
  lazy: true,
  speed: 500,
  loop: true,
  centeredSlides: true,
  autoplay: {
    delay: 10000,
  },
  breakpoints: {
    1200: {
      slidesPerView: 'auto',
      spaceBetween: 135,
      centeredSlides: true,
    },
  },
  pagination: {
    el: '.start-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
  navigation: {
    nextEl: '.start-button-next',
    prevEl: '.start-button-prev',
  },

});
